import React from 'react';
import LoadingIcon from '../../../../LoadingIcon';
import MultiChoice from './MultiChoice';
import ErrorMessage from '../../../../ErrorMessage';
import OfficeService from '../../../../../Services/OfficeService';

export default class OfficeMultiChoice extends React.Component {
  static defaultProps = {
    label: '',
    fieldName: '',
    onChange: () => {},
    selected: [],
    customOfficeList: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: this.props.customOfficeList ? this.props.customOfficeList : [],
      selected: [],
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    if (!this.props.customOfficeList) {
      this.populateListData();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected && !this.props.customOfficeList) {
      this.populateListData();
    }
    if (this.props.customOfficeList) {
      this.customListPopulate(prevProps);
      if (this.state.loading === true) {
        this.setState({ loading: false });
      }
    }
  }

  populateListData() {
    OfficeService.GetOfficesForSelect()
      .then((result) => {
        let optValues = [];
        let selected = [];
        result.forEach((office) => {
          const newValue = { label: office.name, value: office.officeId };
          optValues.push(newValue);
          if (
            this.props.selected &&
            (this.props.selected.includes(office.officeId) || this.props.selected.includes(office.officeId.toString()))
          ) {
            selected.push(newValue);
          }
        });
        this.setState({
          itemList: optValues,
          loading: false,
          selected: selected,
        });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('OMC68');
      });
  }

  customListPopulate(prevProps) {
    if (this.props.customOfficeList !== this.state.itemList) {
      const selected = this.props.customOfficeList.filter(
        (o) => this.props.selected.includes(o.value) || this.props.selected.includes(o.value.toString())
      );
      this.setState({ itemList: this.props.customOfficeList, selected, loading: false });
    } else if (prevProps.selected !== this.props.selected) {
      const selected = this.props.customOfficeList.filter(
        (o) => this.props.selected.includes(o.value) || this.props.selected.includes(o.value.toString())
      );
      this.setState({ selected });
    }
  }

  multiSelectOnChange(selected) {
    this.setState({ selected: selected });
    this.props.onChange(selected);
  }

  renderList() {
    let sel = this.state.selected.map((s) => s.value);
    return (
      <MultiChoice
        label=''
        p-multiselect-panel={true}
        className='rmsc'
        options={this.state.itemList}
        selected={sel}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render() {
    return (
      <div className='w-100'>
        <div className='text-center hover rounded arial'>
          {this.props.label && (
            <label
              className='m-0 p-0 defaultfontsize '
              htmlFor={'htmlidfor' + this.props.fieldName}
            >
              {this.props.label}
            </label>
          )}
          {this.state.loading ? (
            <LoadingIcon
              loading={true}
              className='h6'
            />
          ) : (
            this.renderList()
          )}
        </div>
      </div>
    );
  }
}
